var map = {
	"./arrow.svg": 28669,
	"./bug.svg": 82392,
	"./building-columns.svg": 59416,
	"./calendar-days.svg": 45164,
	"./circle-chart.svg": 55225,
	"./contact.svg": 41350,
	"./directory.svg": 62427,
	"./envelope.svg": 91998,
	"./help.svg": 62655,
	"./home.svg": 69431,
	"./humburger-menu.svg": 84777,
	"./informations.svg": 65247,
	"./logout.svg": 73228,
	"./message-sms.svg": 18531,
	"./message.svg": 74787,
	"./news.svg": 37799,
	"./phone.svg": 67550,
	"./posiedzenia.svg": 30927,
	"./question.svg": 11798,
	"./rejestr.svg": 30427,
	"./save.svg": 46941,
	"./server-white.svg": 60383,
	"./server.svg": 65167,
	"./show-all.svg": 69623,
	"./signal-stream-white.svg": 91543,
	"./sms.svg": 11257,
	"./szablon-posiedzenia.svg": 70121,
	"./user_activiti.svg": 25985,
	"./users.svg": 1118
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 56318;